import FormField from '@cloudscape-design/components/form-field';
import {
  IconAlignCenter,
  IconAlignLeft,
  IconAlignRight,
  IconBold,
  IconItalic,
  IconLink,
  IconUnderline,
} from '@tabler/icons-react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  createButton,
  Editor,
  EditorProvider,
  Toolbar,
} from 'react-simple-wysiwyg';

type TextareaProps = {
  name: string;
  label?: string;
  description?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  rows?: number;
};

const BtnCustomAlignCenter = createButton(
  'Align center',
  <IconAlignCenter />,
  'justifyCenter',
);
const BtnCustomAlignLeft = createButton(
  'Align center',
  <IconAlignLeft />,
  'justifyLeft',
);
const BtnCustomAlignRight = createButton(
  'Align center',
  <IconAlignRight />,
  'justifyRight',
);
const BtnCustomBold = createButton('Bold', <IconBold />, 'bold');
const BtnCustomUnderline = createButton('Bold', <IconUnderline />, 'underline');
const BtnCustomItalic = createButton('Bold', <IconItalic />, 'italic');
const BtnLink = createButton('Link', <IconLink />, ({ $selection }) => {
  if ($selection?.nodeName === 'A') {
    document.execCommand('unlink');
  } else {
    const Selection = document.getSelection()?.toString();
    // eslint-disable-next-line no-alert -- ignore
    const Uri = prompt('URL', '');
    document.execCommand(
      'insertHTML',
      false,
      Uri
        ? `<a href="${Uri}" target="_blank">${Selection ? Selection : Uri}</a>`
        : Selection,
    );
  }
});

const TextareaWysiwyg = ({
  name,
  label,
  description,
  defaultValue = undefined,
  stretch = false,
}: TextareaProps) => {
  const { control, formState } = useFormContext();

  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      errorText={formState.errors[name]?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <EditorProvider>
            <Editor value={field.value} onChange={field.onChange}>
              <Toolbar>
                <BtnCustomAlignLeft />
                <BtnCustomAlignCenter />
                <BtnCustomAlignRight />
                <div
                  style={{
                    height: '10px',
                    width: '1px',
                    backgroundColor: 'grey',
                    marginLeft: '4px',
                    marginRight: '4px',
                  }}
                />
                <BtnCustomBold />
                <BtnCustomItalic />
                <BtnCustomUnderline />
                <div
                  style={{
                    height: '10px',
                    width: '1px',
                    backgroundColor: 'grey',
                    marginLeft: '4px',
                    marginRight: '4px',
                  }}
                />
                <BtnLink />
              </Toolbar>
            </Editor>
          </EditorProvider>
        )}
      />
    </FormField>
  );
};

export default TextareaWysiwyg;
